import { render, staticRenderFns } from "./RoundDuration.vue?vue&type=template&id=bdf7c552&"
import script from "./RoundDuration.vue?vue&type=script&lang=js&"
export * from "./RoundDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports